interface Props {
  angles: Record<string, number>;
  labels: Record<string, string>;
}

export function AnglePanel({ angles, labels }: Props) {
  const entries = Object.entries(angles).filter(([k]) => k in labels);
  if (entries.length === 0) return null;

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2.5">
        <div className="w-7 h-7 rounded-lg bg-[var(--mx-accent-soft)] border border-[var(--mx-accent-border)] flex items-center justify-center">
          <svg className="w-3.5 h-3.5 text-[var(--mx-accent)]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75}
              d="M4 20V4m0 16h16M8 16l3-8 3 4 4-8" />
          </svg>
        </div>
        <div>
          <p className="text-xs font-medium text-[var(--mx-text)]">关节角度</p>
          <p className="text-[10px] text-[var(--mx-text-muted)]">实时生物力学数据</p>
        </div>
      </div>

      <div className="flex flex-col gap-2.5">
        {entries.map(([key, val]) => {
          const pct = Math.min(100, Math.max(4, (val / 180) * 100));
          return (
            <div key={key}>
              <div className="flex items-center justify-between mb-1.5">
                <span className="text-[11px] text-[var(--mx-text-muted)]">{labels[key]}</span>
                <span className="text-xs font-mono font-medium text-[var(--mx-text)] tabular-nums">
                  {Math.round(val)}°
                </span>
              </div>
              <div className="h-1 rounded-full bg-[var(--mx-bg-elevated)] overflow-hidden">
                <div
                  className="h-full rounded-full bg-[var(--mx-accent)] transition-all duration-500 ease-out opacity-80"
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
